import { useWindowDimensions } from 'react-native';

const DESKTOP_BREAKPOINT = 768;

export function useResponsive() {
  const { width } = useWindowDimensions();
  return {
    isDesktop: width >= DESKTOP_BREAKPOINT,
    width,
  };
}
